export default __webpack_public_path__ + "static/media/not-found.d2e6563d.svg";